import { gql } from 'graphql-request';

export interface NoteFragmentType {
  id: string;
  userId: string;
  content: string;
  contentPreview: string;
  createdAt: string;
  updatedAt: string;
  noteType: {
    name: string;
  };
  noteVisibility: {
    name: string;
  };
  noteCompany: {
    companyId: string;
  };
  company: {
    tickerSymbol: string;
    id;
    canonicalURL: string;
  };
}

export const NOTE_FRAGMENT = gql`
  fragment NoteFields on Note {
    id
    userId
    content
    contentPreview
    createdAt
    updatedAt
    noteType {
      name
    }
    noteVisibility {
      name
    }
    noteCompany {
      companyId
    }
    company {
      id
      tickerSymbol
      canonicalURL
    }
  }
`;
